import { wishlistTabForSidebar } from '../Wishlist/wishlistTabForSidebar';
import { cartTabForSidebar } from './Cart Sidebar/cartTabForSidebar';
import './styles/sidebars.scss';
const sidebar = document.createElement('div');
const sidebarTabsHead = document.createElement('div');
const sidebarTabsBody = document.createElement('div');
const overlay = document.querySelector('.main-overlay');
const tabsHeadItems = [];
const tabsBodyItems = [];
let lastFocusedElement = null;
sidebar.setAttribute('class', 'site-sidebar pos:f t:0 r:0 h:100 ov:h ae--from-right');
sidebar.setAttribute('aria-hidden', 'true');
sidebar.setAttribute('tabindex', '0');
sidebar.setAttribute('aria-label', 'Sidebars');
sidebar.setAttribute('aria-describedby', 'adb_escape');
sidebarTabsHead.classList.add('ss__head');
sidebarTabsBody.classList.add('ss__body');
sidebar.append(sidebarTabsHead);
sidebar.append(sidebarTabsBody);
document.body.append(sidebar);
const openSidebar = (tabKey) => {
    switchTab(tabKey);
    document.body.style.overflow = 'hidden';
    if (overlay) {
        overlay.setAttribute('aria-hidden', 'false');
        overlay.addEventListener('click', closeSidebar);
    }
    sidebar.setAttribute('aria-hidden', 'false');
    document.addEventListener('keydown', closeSidebar);
    lastFocusedElement = document.activeElement;
    setTimeout(() => { sidebar.focus(); }, 500);
};
const closeSidebar = (event) => {
    if (event !== undefined &&
        event.code &&
        event.code !== 'Escape')
        return;
    document.removeEventListener('keydown', closeSidebar);
    if (overlay) {
        overlay.setAttribute('aria-hidden', 'true');
        overlay.removeEventListener('click', closeSidebar);
    }
    sidebar.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    lastFocusedElement && lastFocusedElement.focus();
};
const switchTab = (tabKey) => {
    tabsHeadItems.forEach((item) => {
        item.dataset.tabKey === tabKey
            ? item.classList.add('ss__head_item--active')
            : item.classList.remove('ss__head_item--active');
    });
    tabsBodyItems.forEach((item) => {
        item.hidden = item.dataset.tabKey !== tabKey;
    });
};
window.sidebars = window.sidebars ?? {};
[
    wishlistTabForSidebar,
    cartTabForSidebar
].forEach((fun) => {
    const { head, body, tabName, key } = fun(openSidebar);
    head.classList.add('ss__head_item');
    body.classList.add('ss__body_item');
    sidebarTabsHead.append(head);
    sidebarTabsBody.append(body);
    tabsHeadItems.push(head);
    tabsBodyItems.push(body);
    head.addEventListener('click', () => {
        head.dataset.tabKey && switchTab(head.dataset.tabKey);
    });
    window.sidebars[tabName] = {
        show: () => { openSidebar(key); },
        hide: closeSidebar
    };
});
